import React, { useEffect } from 'react';
import { Form, FormInstance, DateSerialized } from 'blueprint-form';
import { Row, Col } from '../../../../grid';
import { StartDate } from '../date';
import { EndDate } from '../date';
import SelectMethod from '../method';
import SelectTime from '../time';
import Weekday from '../weekday';
import Timezone from '../timezone';
import ScheduleRepeat from '../repeat';
import { CardBlock, CardBreakout } from '../../card';
import {
  GetCurrentTZ,
  GetFormalDate,
  ShorthandDate
} from '../../../../libs/time';

interface EpxFallRiskData {
  method: string;
  language: string;
  start: string;
  end?: string;
  tz: string;
  mode?: string;
  times: string[];
  days: number[];
  step?: number;
}

type EpxFallRiskDataRaw = DateSerialized<EpxFallRiskData, 'start' | 'end'>;

export const EpxFallRiskDefaultData: EpxFallRiskData = {
  method: 'message',
  language: 'en',
  start: GetFormalDate(ShorthandDate.Today),
  end: null,
  tz: GetCurrentTZ(),
  mode: 'W',
  times: ['10:00'],
  days: [1, 4],
  step: 1
};

const DATE_FORMAT = 'YYYY-MM-DD';
const { DeserializeDate, SerializeDate } = FormInstance;

interface EpxFallRiskFormProps {
  setForm?: (form: FormInstance<EpxFallRiskDataRaw>) => void;
  onSubmit?: (data: EpxFallRiskData) => void;
  isDisabled?: boolean;
}

const EpxFallRiskForm = ({
  setForm,
  onSubmit: _onSubmit,
  isDisabled
}: EpxFallRiskFormProps): JSX.Element => {
  const serialize = (data: EpxFallRiskDataRaw): EpxFallRiskData => {
    return {
      ...data,
      start: SerializeDate(data.start, DATE_FORMAT),
      end: SerializeDate(data.end, DATE_FORMAT),
      times: data.times.slice(0, 1)
    };
  };
  const deserialize = (data: EpxFallRiskData): EpxFallRiskDataRaw => {
    return {
      ...data,
      start: DeserializeDate(data.start, DATE_FORMAT),
      end: DeserializeDate(data.end, DATE_FORMAT)
    };
  };
  const defaultData = deserialize(EpxFallRiskDefaultData);
  const form = new FormInstance<EpxFallRiskDataRaw, EpxFallRiskData>(
    defaultData,
    { serialize, deserialize }
  );
  useEffect(() => {
    if (setForm) {
      setForm(form);
    }
  }, []);
  const onSubmit = (data: EpxFallRiskData): void => {
    _onSubmit(data);
  };
  return (
    <CardBlock bare>
      <Form form={form} onSubmit={onSubmit} disabled={isDisabled}>
        {(props) => {
          return (
            <>
              <CardBlock>
                <Row>
                  <Col sm={12}>
                    <SelectMethod />
                  </Col>
                </Row>
              </CardBlock>
              <CardBlock>
                <Row>
                  <Col sm={12}>
                    <StartDate label="Start Date" name="start" fill />
                  </Col>
                  <Col sm={12}>
                    <EndDate label="End Date" name="end" />
                  </Col>
                  <Col sm={12}>
                    <SelectTime label="Message At" name="times[0]" />
                  </Col>
                  <Col sm={12}>
                    <Timezone label="Timezone" name="tz" fill />
                  </Col>
                </Row>
              </CardBlock>
              <CardBlock>
                <ScheduleRepeat label="Repeat Messages" />
              </CardBlock>
              {props.values.mode === 'W' ? (
                <CardBreakout>
                  <Weekday name="days" inline />
                </CardBreakout>
              ) : null}
            </>
          );
        }}
      </Form>
    </CardBlock>
  );
};

export default EpxFallRiskForm;
